import { render, staticRenderFns } from "./PatientCenter.vue?vue&type=template&id=78dd39d6"
import script from "./PatientCenter.vue?vue&type=script&lang=ts"
export * from "./PatientCenter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports